module.exports = __webpack_public_path__ + "img/imagem-02-detalhada-palmeiras-03.cefbfec7.png";